export const urlWithHostname = (urlString) => {
  if (urlString.indexOf('/') !== 0) {
    return urlString
  }
  let { origin } = window.location
  if (origin === undefined) {
    origin = `${window.location.protocol}//${window.location.hostname}`
  }
  return `${origin}${urlString}`
}

export const urlWithParams = (urlString, params = {}) => {
  const url = new URL(urlWithHostname(urlString))
  if (window.URLSearchParams !== undefined) {
    if (url.searchParams === undefined) {
      const searchParams = new URLSearchParams()
      Object.keys(params).forEach((key) => {
        searchParams.append(key, params[key])
      })
      url.search = searchParams.toString()
    } else {
      Object.keys(params).forEach((key) => {
        url.searchParams.append(key, params[key])
      })
    }
  } else {
    let string = '?'
    Object.keys(params).forEach((key) => {
      string += `${key}=${params[key]}&`
    })
    if (string.length > 1) {
      url.search = string.substr(0, string.length - 1)
    }
  }
  return url.toString()
}

export const serializeParams = (params) => (
  (Object.keys(params).length > 0) ? `?${
    Object.keys(params).map((key) => (
      `${key}=${params[key]}`
    )).join('&')
  }` : ''
)
